import { axiosPartnerCo } from "../api/axiosPartnerCo";

export const getItemPartnerCoService = async (data: any, shopSiteName: any) => {
    return await axiosPartnerCo.get('/products', {
        params: {
            ...data,
            locale: data.locale?.replace(/_/g, '-'),
        }
    })
}

export const getItemDetailServiceForPartnerCo = async (ids: String, locale: String, companyName: String) => {
    let url = `/products/${ids}?companyName=${companyName}`;
    const params = new URLSearchParams();
    
    if (locale) {
        params.append('locale', locale.toString().replace(/_/g, '-'));
    }
    
    const queryString = params.toString();
    return await axiosPartnerCo.get(`${url}${queryString ? `?${queryString}` : ''}`);
}

export const postCheckout = async (data: any) => {
    return await axiosPartnerCo.post('cart-universal/v2/carts?api_key=YOUR_API_KEY', data)
}

export const getCategories = async (locale: string) => {
    return await axiosPartnerCo.get('/categories', {
        params: {
            locale: locale,
        }
    });
}




